<template>
  <div>
    <div class="condition">
      <div class="search_wrap">
        <el-form :inline="true" :model="formdata" class="form-inline">
          <el-form-item label="核销码">
            <el-input v-model="formdata.code" placeholder="请输入核销码" class="w200" size="small"></el-input>
          </el-form-item>
          <el-form-item label="手机号">
            <el-input v-model="formdata.mobile" placeholder="请输入手机号" class="w200" size="small"></el-input>
          </el-form-item>
          <el-form-item label="活动名称">
            <el-input
              v-model="formdata.activity_title"
              placeholder="请输入活动名称"
              class="w200"
              size="small"
            ></el-input>
          </el-form-item>
          <el-form-item label="参与时间">
            <el-date-picker
              v-model="timeData"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              size="small"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptions1"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="核销状态">
            <el-select
              class="mr10 w130"
              v-model="formdata.status"
              size="small"
              placeholder="请选择核销状态"
            >
              <el-option label="全部" :value="0"></el-option>
              <el-option label="已核销" :value="2"></el-option>
              <el-option label="未核销" :value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="用户昵称">
            <el-input v-model="formdata.nickname" placeholder="请输入用户昵称" class="w200" size="small"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" @click="searchcustomer">搜索</el-button>
            <el-button type="primary" size="small" @click="excelOut">导出</el-button>
            <a ref="download" v-show="false" :href="downloadUrl" :download="downloadfilename"></a>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="table_wrap">
      <el-table :data="tableData" style="width: 100%">
        <el-table-column label="抖音头像/昵称" align="center" width="120px">
          <template slot-scope="scope">
            <img :src="scope.row.dy_avatar" alt width="60px" height="60px" v-if="scope.row.dy_avatar" />
            <img src="@/assets/imgs/userDefult.png" altwu width="60px" height="60px" v-else />
            <p>{{scope.row.dy_nickname}}</p>
          </template>
        </el-table-column>
        <el-table-column prop="tel" label="联系方式" width="160px"></el-table-column>
        <el-table-column label="微信头像/昵称" align="center" width="120px">
          <template slot-scope="scope">
            <img :src="scope.row.wx_avatar" alt width="60px" height="60px" v-if="scope.row.wx_avatar" />
            <img src="@/assets/imgs/userDefult.png" altwu width="60px" height="60px" v-else />
            <p>{{scope.row.wx_nickname}}</p>
          </template>
        </el-table-column>				
        <el-table-column prop="activity_title" label="活动名称"></el-table-column>
        <el-table-column prop="create_time" label="参与时间"></el-table-column>
        <el-table-column prop="sms_res" label="短信结果"></el-table-column>
        <el-table-column prop="verification_text" label="核销信息" width="300px">
          <div slot-scope="scope">
            <p>
              核销状态：{{scope.row.verification_text}}
              <span
                v-if="scope.row.verification_time_text"
              >（{{scope.row.verification_time_text}}）</span>
            </p>
            <p>核销码：{{scope.row.verification_code}}</p>
            <p>有效期：{{scope.row.verification_expire_text}}</p>
          </div>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="120px">
          <template slot-scope="scope">
            <p>
              <el-button
                type="primary"
                size="small"
                icon="el-icon-edit"
                @click="open(scope.row.verification_code)"
                v-if="scope.row.verification_text=='未核销'"
              >核销</el-button>
              <el-button
                type="primary"
                size="small"
                disabled
                v-if="scope.row.verification_text=='已核销'"
              >已核销</el-button>
            </p>
          </template>
        </el-table-column>
      </el-table>
      <div class="pag_wrap">
        <el-pagination
          background
          :page-size="page.page_size"
          :current-page="page.current_page"
          layout="total, prev, pager, next"
          :total="page.total_rows"
          @current-change="pageIndexChange"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api.js";
import { pagination1 } from "@/util/util.js";
export default {
  name: "dyLog",
  filters: {
    //限制文本显示字数,超出部分用...代替
    ellipsis(value) {
      if (!value) return "";
      if (value.length > 10) {
        return value.slice(0, 10) + "...";
      }
      return value;
    }
  },
  data() {
    return {
      showCommission: true,
      downloadUrl: "",
      downloadfilename: "",
      formdata: {
        mobile: "",
        activity_title: "",
        page: 1, // 	整型 	必填 	- 	- 	页码
        code: "", // 	核销码
        start_time: "",
        end_time: "",
        status: 0,
        is_excel_out: 0,
        nickname: ""
      },
      tabIndex: 0,
      timeData: [],
      tableData: [],
      page: {
        current_page: pagination1.current_page,
        page_size: pagination1.page_size,
        total_rows: pagination1.total_rows
      },
      pickerOptions1: {
        disabledDate(time) {
          return time.getTime() > Date.now(); //  - 8.64e7 减去就是不包含今天的
        }
      }
    };
  },
  created() {
    this.init();
  },
  methods: {
    //初始化请求
    init() {
      this.querycustom();
    },
    // 查询
    querycustom() {
      if (this.timeData && this.timeData.length > 0) {
        this.formdata.start_time = this.timeData[0];
        this.formdata.end_time = this.timeData[1];
      } else {
        this.formdata.start_time = "";
        this.formdata.end_time = "";
      }
      this.axios
        .post(api.getDycode, this.formdata)
        .then(response => {
          if (response.data.code == 0) {
            this.tableData = response.data.result;
            this.page = response.data.page;
          }
        })
        .catch(() => {});
    },
    searchcustomer() {
      this.formdata.page = 1;
      this.querycustom();
    },
    pageIndexChange(pageindex) {
      this.formdata.page = pageindex;
      this.querycustom();
    },
    //核销弹框
    open(value) {
      this.$confirm("是否确定核销?（核销码：" + value + "）", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.axios
            .post(api.checkDouyin, { code: value })
            .then(res => {
              if (res.data.code == 0) {
                this.$message.success(res.data.msg);
                setTimeout(() => {
                  //设置延迟执行
                  location.reload();
                }, 2000);
              }
            })
            .catch(res => {});
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消核销"
          });
        });
    },
    //导出excel
    excelOut() {
      this.$confirm("是否确认导出Excel?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.formdata.is_excel_out = 1;
          this.axios
            .post(api.getDycode, this.formdata)
            .then(res => {
              if (res.data.code == 0 && res.data.result.excel_data != "") {
                this.downloadUrl = res.data.result.excel_data;
                this.downloadfilename = res.data.result.excel_filename;
                setTimeout(() => {
                  this.$refs.download.click();
                }, 200);
              }
            })
            .catch(() => {});
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消导出"
          });
        });
    }
  }
};
</script>

<style scoped>
.condition .el-form-item {
  margin-bottom: 10px;
}
</style>